import { jsx as _jsx } from "react/jsx-runtime";
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { SessionKey_Permissions_FE } from '../consts.js';
export const Renderer_RoleNames = () => {
    const roles = SessionKey_Permissions_FE.get().roles;
    return _jsx(LL_V_L, { className: 'container_role-names', children: roles.map(roleName => _jsx("div", { className: 'role-name', id: roleName.key, children: roleName.uiLabel })) });
};
//# sourceMappingURL=Renderer_RoleNames.js.map